<template>
  <div v-if="newPosts.length > 0" class="ugc">
    <div class="header containerV2">
      <h4>How You're Wearing it</h4>
      <p>Tag us and use the hashtag #ratandboa for a chance to be featured.</p>
    </div>
    <InfiniteCarousel>
      <div v-for="(post, index) in newPosts" :key="index">
        <div>
          <UGCCard :post="post" />
        </div>
      </div>
    </InfiniteCarousel>
  </div>
</template>

<script>
import allUGCQuery from "@/graphql/queries/AllUGC.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { mapGetters } from "vuex";
import InfiniteCarousel from "@/components/InfiniteCarousel.vue";
import UGCCard from "@/components/UGCCard.vue";

export default {
  name: "AllUGCV2",
  components: {
    InfiniteCarousel,
    UGCCard,
  },
  data() {
    return {
      metaobjects: [],
      newPosts: [],
    };
  },
  computed: {
    ...mapGetters("app", ["shopId"]),
    posts() {
      const references = unwrapNodes(this.metaobjects?.edges) || [];
      let posts = references;
      posts = posts.map((post) => {
        const fields = post.fields;
        const newPost = {};

        fields.forEach((field) => {
          if (field.type === "number_integer") {
            newPost[field.key] = parseInt(field.value).toLocaleString();
          } else {
            newPost[field.key] = field.value;
          }
        });

        return newPost;
      });

      posts.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

      return posts;
    },
  },
  watch: {
    shopId: {
      handler(val) {
        this.fetchAllUGCPosts(val);
      },
      immediate: true,
    },
  },
  methods: {
    async fetchAllUGCPosts(shopId) {
      if (!shopId) return;

      const posts = await fetch(
        process.env.HOW_TO_WEAR_GADGET_URL + "/all-ugc-posts",
        {
          method: "GET",
          headers: {
            "x-shopify-shop-id": shopId,
          },
        }
      );

      this.newPosts = await posts.json();
    },
  },
  apollo: {
    metaobjects: {
      query: allUGCQuery,
    },
  },
};
</script>

<style lang="scss" scoped>
.ugc {
  padding: 40px 0 60px;
}

.header {
  margin: 0 auto;
  text-align: center;
  margin-bottom: 40px;

  h4 {
    @include editorial-headline(24px);
    text-transform: uppercase;
    margin-bottom: 16px;
  }

  p {
    @include editorial-body(14px);
    text-wrap: balance;
  }
}
</style>
